(function () {
  var observedRoots = new WeakSet();
  var wistiaSelectors = 'wistia-player, .wistia_embed, .wistia_responsive_wrapper, .wistia_responsive_padding';

  function isWistiaVideo(video) {
    if (video.closest(wistiaSelectors)) return true;
    var root = video.getRootNode();
    return root.host && root.host.tagName === 'WISTIA-PLAYER';
  }

  function clearVideoNaming(video) {
    if (!isWistiaVideo(video)) return;
    if (!video.hasAttribute('aria-label') && !video.hasAttribute('aria-labelledby') && !video.hasAttribute('aria-braillelabel')) return;
    video.removeAttribute('aria-label');
    video.removeAttribute('aria-labelledby');
    video.removeAttribute('aria-braillelabel');
  }

  function hasAccessibleName(control) {
    if (control.getAttribute('aria-label')) return true;
    if (control.getAttribute('title')) return true;
    if (control.getAttribute('aria-labelledby')) return true;
    if (control.labels && control.labels.length) return true;
    return false;
  }

  function fixRebuySelects(root) {
    root.querySelectorAll('select.rebuy-select').forEach(function (select) {
      if (hasAccessibleName(select)) return;

      var productBlock = select.closest('.rebuy-product-block, .rebuy-product-info, .rebuy-bundle__items');
      var titleEl = productBlock && productBlock.querySelector('.rebuy-product-title');
      var title = titleEl && titleEl.textContent ? titleEl.textContent.trim() : '';
      var labelText = title ? 'Select options for ' + title : 'Select product options';

      select.setAttribute('aria-label', labelText);
      if (!select.getAttribute('title')) select.setAttribute('title', labelText);
    });
  }

  function fixThirdPartyAria(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('.junip-product-summary-star-ratings-container[aria-label]').forEach(function (rating) {
      if (!rating.hasAttribute('role')) rating.setAttribute('role', 'img');
    });

    // Junip nests vote buttons inside a clickable review card (nested-interactive).
    // Keep vote controls; demote the outer card so it is no longer a focusable button.
    root.querySelectorAll('.junip-review-grid-item-container[role="button"]').forEach(function (card) {
      var nestedControl = card.querySelector(
        'a[href], button, input, select, textarea, [role="button"], [tabindex]:not([tabindex="-1"])'
      );
      if (!nestedControl) return;
      card.removeAttribute('role');
      card.removeAttribute('tabindex');
      card.removeAttribute('aria-label');
    });

    root.querySelectorAll('[role="progressbar"]').forEach(function (progressBar) {
      if (!progressBar.hasAttribute('rivo-ax-bind:aria-valuenow')) return;
      if (!progressBar.hasAttribute('aria-valuenow')) return;
      progressBar.removeAttribute('rivo-ax-bind:aria-valuenow');
    });

    fixRebuySelects(root);
  }

  function fixAccessibilityInRoot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('video').forEach(clearVideoNaming);
    fixThirdPartyAria(root);
  }

  function observeRoot(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);
    fixAccessibilityInRoot(root);
    new MutationObserver(function () {
      fixAccessibilityInRoot(root);
    }).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'aria-label',
        'aria-labelledby',
        'aria-braillelabel',
        'aria-valuenow',
        'rivo-ax-bind:aria-valuenow',
        'role',
        'tabindex'
      ]
    });
  }

  function scanWistiaPlayers() {
    document.querySelectorAll('wistia-player').forEach(function (player) {
      if (player.shadowRoot) {
        observeRoot(player.shadowRoot);
        return;
      }
      if (player.__wistiaA11yShadowObserver) return;
      player.__wistiaA11yShadowObserver = new MutationObserver(function () {
        if (player.shadowRoot) {
          observeRoot(player.shadowRoot);
          player.__wistiaA11yShadowObserver.disconnect();
          player.__wistiaA11yShadowObserver = null;
        }
      });
      player.__wistiaA11yShadowObserver.observe(player, { childList: true });
    });
    observeRoot(document.body);
  }

  function init() {
    scanWistiaPlayers();
    new MutationObserver(function (mutations) {
      var needsScan = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (
            node.matches &&
            (node.matches(wistiaSelectors) ||
              node.matches('video') ||
              node.matches('.rebuy-widget, .rebuy-select, .junip-review-grid-item-container, .junip-product-summary'))
          ) {
            needsScan = true;
            return;
          }
          if (
            node.querySelector &&
            node.querySelector(
              wistiaSelectors +
                ', video, .rebuy-widget, select.rebuy-select, .junip-review-grid-item-container, .junip-product-summary, [role="progressbar"]'
            )
          ) {
            needsScan = true;
          }
        });
      });
      if (needsScan) scanWistiaPlayers();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('wistia-player').then(scanWistiaPlayers);
  }
})();
